import { androidPackageId, iosPackageId, mtDomain } from '../config/constants';

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 *
 * @returns {string}
 */
export function getMobileOperatingSystem() {
    const platform1 = [ 'android', 'ios' ];


    for (let i = 0; i < platform1.length; i++) {

        if (navigator.userAgent.indexOf(platform1[i]) > -1) {

            return platform1[i];
        }
    }

    return 'nil';
}

export const checkIfReactNative = () => navigator.userAgent.includes('react-native');
export const checkIfNotReactNative = () => !navigator.userAgent.includes('react-native');
export const isDomainWeborNative = checkIfReactNative() ? getMobileOperatingSystem() === 'android' ? { package_id: androidPackageId,
    domain: mtDomain } : { package_id: iosPackageId,
    domain: mtDomain } : { domain: mtDomain };


/**
 * 描述.
 *
 * @param {any} bytes - Bytes.
 * @returns {any}
 */
export function bytesToSize(bytes) {
    // eslint-disable-next-line eqeqeq
    if (bytes == 0) {
        return '0 Byte';
    }
    // eslint-disable-next-line radix
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));

    return Math.round(bytes / Math.pow(1024, i), 2);
}

/**
 * 描述.
 *
 * @param {any} str:string
 * @returns {any}
 */
export function isStringJson(str: string) {
    let getString;

    try {
        getString = JSON.parse(str);
    } catch {
        getString = str;
    }

    return getString;
}

